<template>
  <div class="test-report-container">
    <div class="test-report" id="test-report">
      <div class="section-header">
        <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
        <div class="header-title">检测报告</div>
         <img class="header-icon" src="https://suyuan.yueshan2026.cn/profile/upload/2026/01/15/20260115161810A012.png" alt="">
      </div>
      <div class="report-content">
        <div class="report-header">
            <div class="report-page-info">检测报告 共 {{ totalPages }} 页</div>
            <div class="report-stamp">
              <div class="stamp-text">符合要求</div>
            </div>
          </div>
          <div class="report-image-container">
            <button @click="prevPage" class="report-nav-btn nav-prev" :disabled="currentPage === 1 || totalPages <= 1">
              <span class="nav-arrow">&lt;</span>
            </button>
            <div class="report-image">
              <img :src="currentPageImage" :alt="`检测报告第${currentPage}页`" />
            </div>
            <button @click="nextPage" class="report-nav-btn nav-next" :disabled="currentPage === totalPages || totalPages <= 1">
              <span class="nav-arrow">&gt;</span>
            </button>
          </div>
        <div class="report-footer">
          <button @click="viewDetails" class="view-details-btn">
            查看检测详情 &gt;
          </button>
        </div>
      </div>
    </div>
    
    <!-- 大图弹窗 -->
    <div v-if="showLargeImage" class="large-image-overlay" @click="closeLargeImage">
      <div class="large-image-container" @click.stop>
        <!-- 关闭按钮 -->
        <div class="large-image-close" @click="closeLargeImage">
          <img src="https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120100845A001.png" alt="关闭">
        </div>
        
        <!-- 图片展示区域 -->
        <div class="large-image-wrapper">
          <img 
            :src="largeImages[largeImageIndex] || ''" 
            :alt="`检测报告第${largeImageIndex + 1}页`" 
            class="large-image"
          />
          
          <!-- 图片切换按钮 -->
          <div class="large-image-nav" v-if="largeImages.length > 1">
            <div class="nav-btn prev" @click="switchLargeImage('prev')">&lt;</div>
            <div class="nav-btn next" @click="switchLargeImage('next')">&gt;</div>
          </div>
          
          <!-- 图片页码指示器 -->
          <div class="large-image-indicator">
            <span>{{ largeImageIndex + 1 }}/{{ largeImages.length }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productApi from '@/api/modules/product'

export default {
  name: 'TestReport',
  props: {
    batch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentPage: 1,
      reportPages: [], // 检测报告图片数组
      totalPages: 0, // 总页数
      loading: false,
      // 大图弹窗相关数据
      showLargeImage: false,
      largeImageIndex: 0,
      largeImages: []
    }
  },
  computed: {
    currentPageImage() {
      return this.reportPages[this.currentPage - 1] || ''
    }
  },
  mounted() {
    this.getProductData()
  },
  methods: {
    // 获取检测报告数据
    async getProductData() {
      try {
        this.loading = true
        const response = await productApi.getReportList({
          pageNum: 1,
          pageSize: 20,
          batch: this.batch
        })
        
        if (response.success && response.data && response.data.records && response.data.records.length > 0) {
          const reportData = response.data.records[0]
          this.processInspectionImages(reportData.inspectionReport)
        } else {
          this.reportPages = []
          this.totalPages = 0
          this.currentPage = 1
          this.largeImages = []
        }
      } catch (error) {
        console.error('获取检测报告数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    // 将图片字符串转换为数组
    processInspectionImages(inspectionReport) {
      // 重置图片数据
      this.reportPages = []
      this.totalPages = 0
      this.currentPage = 1
      this.largeImages = []
      
      if (!inspectionReport) return
      
      try {
        // 尝试解析为JSON数组
        const images = JSON.parse(inspectionReport)
        if (Array.isArray(images)) {
          this.reportPages = images
        } else {
          // 如果不是数组，作为单个图片处理
          this.reportPages = [inspectionReport]
        }
      } catch (e) {
        // 如果解析失败，检查是否为逗号分隔的字符串
        if (typeof inspectionReport === 'string' && inspectionReport.includes(',')) {
          this.reportPages = inspectionReport.split(',').map(img => img.trim())
        } else {
          // 否则作为单个图片处理
          this.reportPages = [inspectionReport]
        }
      }
      
      // 设置总页数
      this.totalPages = this.reportPages.length
      // 初始化大图数组
      this.largeImages = [...this.reportPages]
    },
    
    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    
    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    
    // 查看检测详情（打开大图弹窗）
    viewDetails() {
      if (this.reportPages.length > 0) {
        this.largeImageIndex = this.currentPage - 1
        this.showLargeImage = true
        // 通知父组件弹窗打开
        this.$emit('modal-open', true)
      }
    },
    
    // 关闭大图弹窗
    closeLargeImage() {
      this.showLargeImage = false
      this.largeImageIndex = 0
      // 通知父组件弹窗关闭
      this.$emit('modal-open', false)
    },
    
    // 大图弹窗中切换图片
    switchLargeImage(direction) {
      if (direction === 'next') {
        this.largeImageIndex = (this.largeImageIndex + 1) % this.largeImages.length
      } else {
        this.largeImageIndex = (this.largeImageIndex - 1 + this.largeImages.length) % this.largeImages.length
      }
    }
  }
}
</script>

<style scoped>
.test-report {
  padding: 0;
  /* background-color: #fff; */
}




.report-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.report-page-info {
  font-size: 14px;
  color: #666;
}

.report-stamp {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(76, 175, 80, 0.2);
  border: 3px solid #4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-15deg);
}

.stamp-text {
  font-size: 14px;
  font-weight: bold;
  color: #4caf50;
  text-align: center;
  line-height: 1.3;
}

.report-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 20px;
}

.report-nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}

.report-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nav-arrow {
  font-size: 18px;
  color: #666;
}

.report-image {
  flex: 1;
  max-width: 80%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.report-image img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.report-footer {
  text-align: center;
}

.view-details-btn {
  background: none;
  border: none;
  color: #4A89FE;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 10px 20px;
}

/* 大图弹窗样式 */
.large-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.large-image-container {
  position: relative;
  width: 95%;
  height: 90%;
  max-width: 900px;
  max-height: 600px;
}

.large-image-close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
}

.large-image-close img {
  width: 20px;
  height: 20px;
}

.large-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.large-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.large-image-nav {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.large-image-nav .nav-btn {
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.large-image-indicator {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
}

</style>